<template>
  <div class="my-6">
    <div class="flex items-center mb-4">
      <div class="w-3 h-8 bg-subheader-line mr-3"></div>
      <h2 class="text-2xl md:text-3xl font-bold text-slate-800">
        {{ title }}
      </h2>
    </div>
    <p class="text-lg text-slate-700">
      {{ description }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
  },
};
</script>
